import { Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Box } from '@mui/material';
import { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useQuoteState } from 'shared/contexts';
import { Expense } from 'shared/types';
import { ExpenseSummary } from './expense-summary';
import { SxProps, Theme } from '@mui/material';

const rootStyles: SxProps<Theme> = {
  width: '100%',
};
const expensesStyles: SxProps<Theme> = (theme: Theme) => ({
  marginTop: '20px',
  width: '100%',
  '& .MuiTableRow-head': {
    backgroundColor: theme.palette.background.paper,
  },
  '& .MuiTableCell-head': {
    fontWeight: 'normal',
    '&:nth-of-type(1)': {
      paddingLeft: theme.spacing(5),
    },
  },
});

export function ExpenseDetails() {
  const { newExpense } = useQuoteState();
  const { watch } = useFormContext();
  const { fields, remove, append } = useFieldArray({
    name: 'expenses',
  });

  const watchExpenses = watch('expenses') as Expense[];
  const controlledFields = fields.map((field, index) => ({
    ...field,
    ...watchExpenses?.[index],
  }));

  useEffect(() => {
    if (newExpense) {
      append(newExpense);
    }
  }, [newExpense, append]);

  return (
    <Box sx={rootStyles}>
      <Box sx={expensesStyles}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align='left'>Expense Type</TableCell>
                <TableCell align='left'>Quantity</TableCell>
                <TableCell align='left'>Price</TableCell>
                <TableCell align='left'>Total Price</TableCell>
                <TableCell align='right' />
              </TableRow>
            </TableHead>
            <TableBody>
              {controlledFields.map((expense, index) => (
                <ExpenseSummary key={expense.id} expense={expense} index={index} remove={remove} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}
